module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("UnitNote", "Change the notes of this device") ))==null?'':__t)+
'</legend><div><textarea class="no-label textarea-note textarea-note-write" data-input="unit-notes" maxlength="320" placeholder="'+
((__t=( i18n.tc( 'UnitNote', 'Leave a note here...' ) ))==null?'':__t)+
'">'+
((__t=( notes ))==null?'':__t)+
'</textarea></div><p>'+
((__t=( i18n.tc("UnitNote", "Enter important information for your installation here, e.g. special notes regarding zones or temperature readings . Maximum 320 characters.")))==null?'':__t)+
'</p></fieldset><fieldset class="button-wrap"><button data-click="notes-cancel">'+
((__t=( i18n.tc("UnitNote", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="notes-submit">'+
((__t=( i18n.tc("UnitNote", "Save") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
